import type { KeyboardEvent } from 'react';
import { isRichTextEmpty } from 'shared/utils/richText/length';

export function isPrintableKey(event: KeyboardEvent<HTMLElement>): boolean {
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return false;
  }
  return event.key.length === 1;
}

/**
 * Fixed one-line layout (56px, no wrapping) only while the field is empty and
 * shows its placeholder. Any text uses the normal layout, which wraps and
 * grows, so a long single paragraph is not cut off under the toolbar toggle.
 */
export function isCompactSingleLineLayout(value: string): boolean {
  return isRichTextEmpty(value);
}

export function hasRichTextValue(value: string): boolean {
  return !isRichTextEmpty(value);
}

/** Try immediately, then on the next animation frames until success or `extraFrames` runs out. */
export function scheduleNestedAnimationFrames(
  tryFocus: () => boolean,
  extraFrames: number
): () => void {
  const frameIds: number[] = [];
  let cancelled = false;

  const tick = (remaining: number): void => {
    if (cancelled || tryFocus() || remaining === 0) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      tick(remaining - 1);
    });
    frameIds.push(frameId);
  };

  tick(extraFrames);

  return (): void => {
    cancelled = true;
    frameIds.forEach((frameId) => {
      window.cancelAnimationFrame(frameId);
    });
  };
}
